import React, { useEffect, useState } from "react";
import "./AuditionRounds.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import moment from "moment";
import { Markup } from "interweave";
import noImage from "../../../assets/images/settings/no-image.png";
import icon3 from "../../../assets/images/Rounds/icons/flag 1.png";
import Calender from "../../../assets/images/calendar.png";
import { Tab, Nav } from "react-bootstrap";

import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import LoaderPost from "../../Reuseable/LoaderPost";

const AuditiionRoundInstructionDetails = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const [activeRoundData, setActiveRoundData] = useState({});
  const [roundInstruction, setRoundInstruction] = useState({});
  const [rounds, setRounds] = useState([]);

  const getRoundInstruction = () => {
    setLoading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(
          `/api/audition-admin/audition/get-round-instruction/${event.id}/${activeRound}`
        )
        .then((res) => {
          if (res?.data?.status === 200) {
            if (res?.data?.auditon_round_instruction != null) {
              setRoundInstruction(res?.data?.auditon_round_instruction);
            } else {
              setRoundInstruction({});
            }
            setLoading(false);
          }
        });
    });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/audition-admin/audition-event/with-rounds/${slug}`).then((res) => {
      if (res?.data?.status === 200) {
        setEvent(res?.data?.event);
        setActiveRound(res?.data?.event?.active_round_info_id);
        setRounds(res?.data?.event?.audition_round);
      }
    });
  };

  useEffect(() => {
    getRoundInstruction();
    if (rounds.length > 0) {
      const result = rounds.find((round) => round.id == activeRound);
      setActiveRoundData(result);
    }
  }, [activeRound, rounds]);
  
  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
          <>
            <div className="container bg-dark py-3 rounded-3">
              <div className="row m-2">
                <h5 className="text-warning fw-bold ">Instructions</h5>

                {roundInstruction && (
                  <Markup
                    className="text-light"
                    content={roundInstruction?.instruction}
                  />
                )}
              </div>

              <div className="row mx-2 my-3">
                <div className="col-md-6 mb-3">
                  <div className="card card-bg p-2">
                    <img
                      src={
                        roundInstruction?.image != null
                          ? imageCdnUrl+roundInstruction?.image
                          : noImage
                      }
                      alt=""
                      className="img-fit-cover"
                      maxHeight="300px"
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="card card-bg p-2">
                    <ReactPlayer
                      url={
                        roundInstruction.video
                          ? videoCdnUrl+roundInstruction.video
                          : null
                      }
                      playing={false}
                      volume={1}
                      className="img-fit-cover"
                      width="100%"
                      maxHeight="300px"
                      controls={true}
                      autoPlay={true}
                    />
                  </div>
                </div>
              </div>

              <div className="row d-flex justify-content-center mx-2">
                <div className="col-md-3 mb-3">
                  <div className="card bg-info">
                    <div className="d-flex align-items-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={icon3} alt="" />
                      </div>
                      <div className="p-2">
                        <small className="text-light">Round Start</small>
                        <h5 className="text-light fontSizeStatus">
                          {activeRoundData?.round_start_date ??
                            moment(activeRoundData?.round_start_date).format(
                              "LL"
                            )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <div className="card bg-warning">
                    <div className="d-flex align-items-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={icon3} alt="" />
                      </div>
                      <div className="p-2">
                        <small className="text-light">Round End</small>
                        <h5 className="text-light fontSizeStatus">
                          {activeRoundData?.round_end_date ??
                            moment(activeRoundData?.round_end_date).format(
                              "LL"
                            )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-2 mt-3">
                <div className="card card-bg head-line mb-2 mb-2">
                  <div className="text-light d-flex p-2">
                    <h5 className="mx-3 text-white p-2">
                      Post Requirements Before Started Rounds
                    </h5>
                  </div>
                </div>
              </div>

              <div className="row ms-5 mt-4 mb-3">
                <div className="row justify-content-center">
                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">Start Date</small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.round_start_date ??
                              moment(activeRoundData?.round_start_date).format(
                                "LL"
                              )}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">End Date</small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.round_end_date ??
                              moment(activeRoundData?.round_end_date).format("LL")
                            }
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {activeRoundData?.round_type == 0 ? (
                    <>
                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Video Upload Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.video_upload_start_date ??
                                  moment(
                                      activeRoundData?.video_upload_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Video Upload End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.video_upload_end_date ??
                                  moment(
                                      activeRoundData?.video_upload_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">
                            Marking Start Date
                          </small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.jury_or_judge_mark_start_date ??
                              moment(
                                  activeRoundData?.jury_or_judge_mark_start_date
                              ).format("LL")}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">Marking End Date</small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.jury_or_judge_mark_end_date ??
                              moment(
                                  activeRoundData?.jury_or_judge_mark_end_date
                              ).format("LL")}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">
                            Result Publish Start Date
                          </small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.result_publish_start_date ??
                              moment(
                                  activeRoundData?.result_publish_start_date
                              ).format("LL")}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-3">
                    <div className="card head-line card-bg-p px-3 py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <img src={Calender} alt="" className="p-2" />
                        </div>
                        <div>
                          <small className="text-light">
                            Result Publish End Date
                          </small>
                          <h5 className="text-warning fw-bold">
                            {activeRoundData?.result_publish_end_date ??
                              moment(
                                  activeRoundData?.result_publish_end_date
                              ).format("LL")}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {activeRoundData?.round_type == 0 ? (
                    <>
                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_start_date ??
                                  moment(activeRoundData?.appeal_start_date).format(
                                    "LL"
                                  )}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_end_date ??
                                  moment(activeRoundData?.appeal_end_date).format(
                                    "LL"
                                  )}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Video Upload Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_video_upload_start_date ??
                                  moment(
                                      activeRoundData?.appeal_video_upload_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Video Upload End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_video_upload_end_date ??
                                  moment(
                                      activeRoundData?.appeal_video_upload_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Marking Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_jury_or_judge_mark_start_date ??
                                  moment(
                                      activeRoundData?.appeal_jury_or_judge_mark_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Marking End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_jury_or_judge_mark_end_date ??
                                  moment(
                                      activeRoundData?.appeal_jury_or_judge_mark_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Result Publish Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_result_publish_start_date ??
                                  moment(
                                      activeRoundData?.appeal_result_publish_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card head-line card-bg-p px-3 py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Appeal Result Publish End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRoundData?.appeal_result_publish_end_date ??
                                  moment(
                                      activeRoundData?.appeal_result_publish_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </>
        </>
      )}
    </>
  );
};

export default AuditiionRoundInstructionDetails;
